import { Component } from '@angular/core';
import { RevealDirective } from '../../../directives/reveal.directive';

@Component({
  selector: 'app-assistant',
  standalone: true,
  imports: [RevealDirective],
  templateUrl: './assistant.component.html',
})
export class AssistantComponent {}
